import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import WPButton from "../../packages/WPButton";

const ReferenceConditionRenderer = ({ context, node }) => {
  const { t } = useTranslation();

  const handleClick = useCallback(
    (e) => {
      if (context?.handleReferenceRowClick) {
        context.handleReferenceRowClick({
          data: node.data,
        });
      }
    },
    [context, node.data]
  );

  return (
    <WPButton onClick={handleClick}>
      {t("referenceConditions.setAsReferenceCondition")}
    </WPButton>
  );
};

export default ReferenceConditionRenderer;
